import { S3_BUCKET_URL } from '@/constants';

export interface SummaryScreenConfig {
  mainImage: string;
}

export const getSummaryScreenConfig = (
  screenName: 'summary-intro' | 'summary-deep' | 'summary-final',
  notes?: string[],
): SummaryScreenConfig => {
  const isLucy = notes?.includes('lucy');
  const basePath = isLucy ? 'lucy' : 'jia';

  return {
    mainImage: `${S3_BUCKET_URL}/layout-own-ai-dominate-v2/${basePath}/summary-screens/${screenName}-background.png`,
  };
};
